module.exports = __webpack_public_path__ + "static/img/Tom_McDonald_mobile.0617a76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_McDonald_mobile.jpg
// module id = RxJ/
// module chunks = 0